import { css } from "@emotion/css";
import { Colors } from "@snapchat/snap-design-system";

export const retentionContainer = css`
    min-height: 104px;

    :not(:last-child) {
        margin-bottom: 16px;
    }

    > div {
        padding: 16px 0 16px 16px;

        :not(:last-child) {
            border-right: 1px solid ${Colors.Gray.V50};
        }
    }
`;

export const contentHeader = css`
    margin-bottom: 20px;
`;
